import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-accf93b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-header__top" }
const _hoisted_2 = { class: "dashboard-header__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "dashboard-header__right header-control" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_7 = { class: "dashboard-header__breadcrumb" }

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import SwitchLang from "@/components/lang/SwitchLang.vue";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue";
import UserInform from "@/layouts/dashboard/nav/user/UserInfor.vue";
import { HOME } from '@/const/path'
import commons from "@/utils/Common";

interface Props {
  navbarFixed: boolean;
  sidebarCollapsed: boolean;
  sidebarColor?: string;
  sidebarTextColor?: string;
  sidebarSelectedTextColor?: string;
  notificationsData?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardHeader',
  props: {
    navbarFixed: { type: Boolean, default: false },
    sidebarCollapsed: { type: Boolean, default: false },
    sidebarColor: { default: "primary" },
    sidebarTextColor: { default: "primary" },
    sidebarSelectedTextColor: { default: "white" },
    notificationsData: { default: () => [] }
  },
  emits: ["toggleSidebar", "toggleSettingsDrawer"],
  setup(__props: any) {

const props = __props;



const router = useRouter();
const top = ref(0);
const company = ref<Record<string, string>>({});

const sidebarColorVal = computed(() => props.sidebarColor || "primary");
const sidebarTextColorVal = computed(() => props.sidebarTextColor || "primary");
const sidebarSelectedTextColorVal = computed(
  () => props.sidebarSelectedTextColor || "white"
);

const companyName = computed(
  () => company.value.sub_name || company.value.subName || "KIMAHOME"
);
const companyTagline = computed(
  () => company.value.summary || ""
);
const companyLogo = computed(
  () => company.value.logo || company.value.urlLogo || ""
);

const resizeEventHandler = () => {
  top.value = top.value ? 0 : -0.01;
};

const goHome = () => {
  router.push(HOME);
};

const loadCompany = () => {
  const data = commons.getCokiesCompany();
  if (data) {
    company.value = data;
  }
};

onMounted(() => {
  loadCompany();
  window.addEventListener("resize", resizeEventHandler);
});

return (_ctx: any,_cache: any) => {
  const _component_h_button = _resolveComponent("h-button")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.navbarFixed ? 'a-affix' : 'div'), { "offset-top": top.value }, {
    default: _withCtx(() => [
      _createElementVNode("header", {
        class: _normalizeClass(["dashboard-header", [
        `dashboard-header--bg-${sidebarColorVal.value}`,
        `dashboard-header--text-${sidebarTextColorVal.value}`,
        `dashboard-header--selected-${sidebarSelectedTextColorVal.value}`,
      ]])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "dashboard-header__toggle sidebar-toggler",
              "aria-label": "Toggle sidebar",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar', !_ctx.sidebarCollapsed), resizeEventHandler()))
            }, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_h_button, {
              type: "link",
              class: "dashboard-header__action"
            }, {
              default: _withCtx(() => [
                _createVNode(SwitchLang)
              ]),
              _: 1
            }),
            _createVNode(_component_h_button, {
              type: "link",
              class: "dashboard-header__action",
              ref: "secondarySidebarTriggerBtn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleSettingsDrawer', true)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 512),
            _createVNode(UserInform, { variant: "dashboard" })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(Breadcrumb)
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["offset-top"]))
}
}

})